import { render, staticRenderFns } from "./vipDetail.vue?vue&type=template&id=ec775abe&scoped=true&"
import script from "./vipDetail.vue?vue&type=script&lang=js&"
export * from "./vipDetail.vue?vue&type=script&lang=js&"
import style0 from "./vipDetail.vue?vue&type=style&index=0&id=ec775abe&scoped=true&lang=css&"
import style1 from "./vipDetail.vue?vue&type=style&index=1&id=ec775abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec775abe",
  null
  
)

export default component.exports